import React from "react";
import { FormikProps, Field } from "formik";
import { InputColumn, InputText, InputValidation } from "src/components/Inputs";

const Form: React.FC<FormikProps<UnitValuesProps>> = ({ errors }) => {
  return (
    <>
      <InputColumn label="Nome">
        <Field name="name" component={InputText} required={true} />
        <InputValidation message={errors.name} />
      </InputColumn>
      <InputColumn label="Abreviação">
        <Field name="abbreviation" component={InputText} required={true} />
        <InputValidation message={errors.abbreviation} />
      </InputColumn>
    </>
  );
};

export default Form;
